@if (menuItems$ | async; as menus) {
  @if (menuService.hasMenuItems) {
    <ul class="side-menu nav flex-column bg-dark d-print-none d-none d-xxl-block">
      @for (menuItem of menus; track menuItem.name) {
        <li class="nav-item">
          <a
            class="nav-link text-white"
            [routerLink]="menuItem.route"
            [target]="menuItem.openInNewTab ? '_blank' : undefined"
            routerLinkActive="active"
            >{{ translationService.translateMenu(menuItem.name) }}</a
          >
        </li>
      }
    </ul>
  }
}
